var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIncrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.03 37.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#db3326;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_increase") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.06,37.78a1.06,1.06,0,0,1,0-2.11L56,35.46A1.09,1.09,0,0,1,57,36.51,1.06,1.06,0,0,1,56,37.57l-54.92.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.12,28.28a1.05,1.05,0,0,1-.76-.32L13.91,17.12,3.27,27.56a1.06,1.06,0,1,1-1.48-1.51l11.4-11.19a1.11,1.11,0,0,1,.75-.3,1.06,1.06,0,0,1,.74.32L25.16,25.76,52.69.7a1.06,1.06,0,1,1,1.42,1.56L25.83,28A1.05,1.05,0,0,1,25.12,28.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.61,10.55A1.06,1.06,0,0,1,52.55,9.5V2.11H44.11a1.06,1.06,0,0,1,0-2.11h9.5a1.06,1.06,0,0,1,1.06,1.06V9.5A1.06,1.06,0,0,1,53.61,10.55Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIncrease);
export default __webpack_public_path__ + "static/media/icon_increase.696f8e58aba200aed7e0d7239a1a97b6.svg";
export { ForwardRef as ReactComponent };